export default __webpack_public_path__ + "static/media/fast_food.13e6388c.svg";